/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataSourceLoaderStateResponse } from '../models/DataSourceLoaderStateResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LoaderService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Trigger a bulk data load for source sealog-hd-stills
     * Trigger a bulk data load for source sealog-hd-stills
     * @returns DataSourceLoaderStateResponse Successful Response
     * @throws ApiError
     */
    public triggerDataLoadSealogHdStills(): CancelablePromise<DataSourceLoaderStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/loader/sealog-hd-stills/',
        });
    }

    /**
     * Trigger a bulk data load for source sealog-hd-video
     * Trigger a bulk data load for source sealog-hd-video
     * @returns DataSourceLoaderStateResponse Successful Response
     * @throws ApiError
     */
    public triggerDataLoadSealogHdVideo(): CancelablePromise<DataSourceLoaderStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/loader/sealog-hd-video/',
        });
    }

    /**
     * Trigger a bulk data load for source fishbase
     * Trigger a bulk data load for source fishbase
     * @returns DataSourceLoaderStateResponse Successful Response
     * @throws ApiError
     */
    public triggerDataLoadFishbase(): CancelablePromise<DataSourceLoaderStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/loader/fishbase/',
        });
    }

    /**
     * Trigger a bulk data load for source sealifebase
     * Trigger a bulk data load for source sealifebase
     * @returns DataSourceLoaderStateResponse Successful Response
     * @throws ApiError
     */
    public triggerDataLoadSealifebase(): CancelablePromise<DataSourceLoaderStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/loader/sealifebase/',
        });
    }

    /**
     * Trigger a bulk data load for source BioCLIP-target-taxa
     * Trigger a bulk data load for source BioCLIP-target-taxa
     * @returns DataSourceLoaderStateResponse Successful Response
     * @throws ApiError
     */
    public triggerDataLoadBioClipTargetTaxa(): CancelablePromise<DataSourceLoaderStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/loader/BioCLIP-target-taxa/',
        });
    }

}
